import React, { useState } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
} from "../../../common-components";

const RegistrationPopUp = ({
  display,
  onCloseClick,
  width,
  onRegClick,
  email,
  onEmailChange,
  cellNumber,
  onCellChange,
  tandc,
  onTermsClick,
  password,
  onPasswordChange,
  confirmPassword,
  onConfirmPasswordChange,
  onFirstNameChange,
  onLastNameChange,
  lastName,
  firstName,
  onEmailLoginChange,
  emailLogin,
  passwordLogin,
  onPasswordLoginChange,
  onLoginClick,
}) => {
  const [selectedDisplay, setSelectedDisplay] = useState("login");
  const [hoverSelect, setHoverSelect] = useState(null);
  return (
    <div
      style={{
        width: display ? "100%" : 0,
        height: display ? "100%" : 0,
        position: "absolute",
        overflow: "hidden",
        backgroundColor: colors.primaryBlue50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 0,
        // transition: "all 0.4s",
      }}
    >
      <div
        style={{
          height: display ? (width > 599 ? 700 : "100%") : 0,
          width: display ? (width > 599 ? 400 : "100%") : 0,
          backgroundColor: colors.white,
          borderRadius: width > 599 ? 20 : 0,
          borderStyle: "solid",
          borderWidth: 3,
          borderColor: colors.white,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          transition: "all 0.4s",
          zIndex: 1,
          marginTop: width > 599 ? 40 : 0,
          marginBottom: width > 899 ? 30 : 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div>
          <img
            alt="logo"
            src={require("../../../../images/base-logo-desgns/driverfrinedlogo4.png")}
            style={{ marginTop: 0, height: 80, marginBottom: 0 }}
          />
        </div>
        {/* <div style={{ marginTop: 20, marginBottom: 10 }}>
          <div
            style={{
              color: colors.primaryBlue,
              fontSize: 27,
              fontWeight: "bold",
              width: "100%",
              textAlign: "center",
            }}
          >
            {selectedDisplay.toLocaleUpperCase()}
          </div>
        </div> */}
        <div
          style={{
            minHeight: 60,
            height: 60,
            width: "100%",
            // backgroundColor: "#00000030",
            display: "flex",
            cursor: "pointer",
          }}
        >
          <div
            onMouseOver={() => setHoverSelect("login")}
            onMouseOut={() => setHoverSelect(null)}
            onClick={() => setSelectedDisplay("login")}
            style={{
              fontWeight: "bold",
              height: "100%",
              flex: 0.33,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color:
                selectedDisplay === "login"
                  ? colors.white
                  : hoverSelect === "login"
                  ? colors.white
                  : colors.white,
              backgroundColor:
                selectedDisplay === "login"
                  ? colors.greenDark
                  : hoverSelect === "login"
                  ? colors.greenLight
                  : "#00000030",
            }}
          >
            LOGIN
          </div>
          <div
            onMouseOver={() => setHoverSelect("registeration")}
            onMouseOut={() => setHoverSelect(null)}
            onClick={() => setSelectedDisplay("registeration")}
            style={{
              fontWeight: "bold",
              height: "100%",
              flex: 0.34,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color:
                selectedDisplay === "registeration"
                  ? colors.white
                  : hoverSelect === "registeration"
                  ? colors.white
                  : colors.white,
              backgroundColor:
                selectedDisplay === "registeration"
                  ? colors.greenDark
                  : hoverSelect === "registeration"
                  ? colors.greenLight
                  : "#00000030",
            }}
          >
            REGISTER
          </div>
          <div
            onMouseOver={() => setHoverSelect("forgot password")}
            onMouseOut={() => setHoverSelect(null)}
            onClick={() => setSelectedDisplay("forgot password")}
            style={{
              fontWeight: "bold",
              height: "100%",
              flex: 0.33,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color:
                selectedDisplay === "forgot password"
                  ? colors.white
                  : hoverSelect === "forgot password"
                  ? colors.white
                  : colors.white,
              backgroundColor:
                selectedDisplay === "forgot password"
                  ? colors.greenDark
                  : hoverSelect === "forgot password"
                  ? colors.greenLight
                  : "#00000030",
            }}
          >
            FORGOT PASSWORD
          </div>
        </div>
        {selectedDisplay === "registeration" ? (
          <div
            style={{
              flex: 1,
              widht: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {/* <div
              style={{
                width: width > 599 ? "75%" : "80%",
                marginTop: 10,
                fontSize: 12,
              }}
            >
              We are going to need some simple information in order to create
              your account..
            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                width: "75%",
                marginTop: 30,
              }}
            >
              <TextInputField
                labelTitle={"First Name"}
                mini={true}
                width={"40%"}
                size={"100%"}
                value={firstName}
                onChange={onFirstNameChange}
              />
              <div style={{ width: 20 }} />
              <TextInputField
                labelTitle={"Last Name"}
                mini={true}
                width={"40%"}
                size={"100%"}
                value={lastName}
                onChange={onLastNameChange}
              />
            </div>

            <TextInputField
              labelTitle={"Email"}
              mini={true}
              width={"100%"}
              size={"70%"}
              value={email}
              onChange={onEmailChange}
            />
            <TextInputField
              labelTitle={"Cell number"}
              mini={true}
              width={"100%"}
              size={"70%"}
              value={cellNumber}
              onChange={onCellChange}
            />
            <TextInputField
              labelTitle={"Password"}
              mini={true}
              width={"100%"}
              size={"70%"}
              value={password}
              onChange={onPasswordChange}
            />
            <TextInputField
              labelTitle={"Confirm Password"}
              mini={true}
              width={"100%"}
              size={"70%"}
              value={confirmPassword}
              onChange={onConfirmPasswordChange}
            />
            <div style={{ width: "70%", marginTop: 20 }}>
              <CheckInput
                selected={tandc}
                label={"TERMS & CONDISTIONS"}
                onClick={onTermsClick}
              />
            </div>
            <div style={{ width: "70%", marginTop: 20 }}>
              <CheckInput
                selected={tandc}
                label={"TERMS & CONDISTIONS"}
                onClick={onTermsClick}
              />
            </div>
          </div>
        ) : null}
        {selectedDisplay === "login" ? (
          <div
            style={{
              flex: 1,
              widht: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <TextInputField
              labelTitle={"Username | Email"}
              mini={true}
              value={emailLogin}
              onChange={onEmailLoginChange}
              marginTop={40}
            />
            <TextInputField
              labelTitle={"Password"}
              mini={true}
              showPassword={true}
              value={passwordLogin}
              onChange={onPasswordLoginChange}
            />
          </div>
        ) : null}
        {selectedDisplay === "forgot password" ? (
          <div
            style={{
              flex: 1,
              widht: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <TextInputField
              labelTitle={"Email"}
              mini={true}
              width={"100%"}
              size={"70%"}
              marginTop={40}
            />
            <div
              style={{
                width: width > 599 ? "75%" : "80%",
                marginTop: 10,
                fontSize: 12,
              }}
            >
              Type the email of the account user that has forgot thier password,
              we will send you a verifaction code to your email to allow for
              password change...
            </div>
          </div>
        ) : null}
        {selectedDisplay === "registeration" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 40,
              marginTop: 20,
            }}
          >
            <BaseButtons
              onClick={onRegClick}
              label={"SUBMIT"}
              borderRadius={8}
              width={280}
              disabled={
                password === confirmPassword &&
                firstName.length > 3 &&
                lastName.length > 2 &&
                email.length > 7 &&
                tandc
                  ? false
                  : true
              }
              backgroundColor={colors.greenDark}
            />
            <div style={{ height: 10 }} />
            <BaseButtons
              onClick={onCloseClick}
              label={"CLOSE"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
          </div>
        ) : null}
        {selectedDisplay === "login" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 40,
              marginTop: 20,
            }}
          >
            <BaseButtons
              onClick={onLoginClick}
              label={"LOGIN"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
            <div style={{ height: 10 }} />
            <BaseButtons
              onClick={onCloseClick}
              label={"CLOSE"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
          </div>
        ) : null}
        {selectedDisplay === "forgot password" ? (
          <div>
            <BaseButtons
              onClick={onCloseClick}
              label={"VALIDATE CODE"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
            <div style={{ height: 10 }} />
            <BaseButtons
              onClick={onCloseClick}
              label={"REQUEST CODE"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
            <div style={{ height: 10 }} />
            <BaseButtons
              onClick={onCloseClick}
              label={"CLOSE"}
              borderRadius={8}
              width={280}
              backgroundColor={colors.greenDark}
            />
          </div>
        ) : null}
        <div style={{ height: 20 }} />
      </div>
    </div>
  );
};

export default RegistrationPopUp;
